export default __webpack_public_path__ + "static/media/1Dark.dc238e41.JPG";